import calibrationImage from "@assessment/assets/images/calibrationImg.png";
import { useAppSelector } from "@assessment/store/store";
import { useTranslation } from "react-i18next";

const CalibrationInfoModal = () => {
  const { t } = useTranslation();
  const user = useAppSelector((state) => state.UserInfoSlice.profile);
  const hasAssessmentRecOrgs = user?.hasAssessmentRecOrgs;
  const isHitachiOrg = user.isHitachiOrg;

  const contactEmail =
    hasAssessmentRecOrgs && !isHitachiOrg
      ? "amith.c@globallogic.com"
      : "support.glx@globallogic.com";

  const calibrationInfoData = {
    initialSteps: [
      {
        title: t(
          "assessment.systemCheck.calibrationInfo.initialSteps.step1.title"
        ),
        description: t(
          "assessment.systemCheck.calibrationInfo.initialSteps.step1.description"
        )
      },
      {
        title: t(
          "assessment.systemCheck.calibrationInfo.initialSteps.step2.title"
        ),
        description: t(
          "assessment.systemCheck.calibrationInfo.initialSteps.step2.description"
        )
      },
      {
        title: t(
          "assessment.systemCheck.calibrationInfo.initialSteps.step3.title"
        ),
        description: t(
          "assessment.systemCheck.calibrationInfo.initialSteps.step3.description"
        )
      },
      {
        title: t(
          "assessment.systemCheck.calibrationInfo.initialSteps.step4.title"
        ),
        description: t(
          "assessment.systemCheck.calibrationInfo.initialSteps.step4.description"
        )
      },
      {
        title: t(
          "assessment.systemCheck.calibrationInfo.initialSteps.step5.title"
        ),
        description: t(
          "assessment.systemCheck.calibrationInfo.initialSteps.step5.description"
        )
      }
    ],
    laterSteps: [
      t("assessment.systemCheck.calibrationInfo.laterSteps.step1"),
      t("assessment.systemCheck.calibrationInfo.laterSteps.step2"),
      t("assessment.systemCheck.calibrationInfo.laterSteps.step3", {
        contactEmail
      })
    ]
  };

  return (
    <>
      <div className="text-md text-gray-500 mb-5">
        {t("assessment.systemCheck.calibrationInfo.heading")}
      </div>
      <ol>
        {calibrationInfoData.initialSteps.map((step, index) => (
          <li key={index} className="my-1">
            <span className="font-semibold text-gray-700">{index + 1}.</span>{" "}
            <span className="font-semibold text-gray-700">{step.title}</span> -{" "}
            <span>{step.description}</span>
          </li>
        ))}
      </ol>
      <div className="flex justify-center my-5">
        <div className="w-1/2">
          <img className="rounded-xl" src={calibrationImage} />
        </div>
      </div>
      <div className="text-md text-gray-500 mb-5">
        {t("assessment.systemCheck.calibrationInfo.followUpHeading")}
      </div>
      <div className="">
        <ul>
          {calibrationInfoData.laterSteps.map((step, index) => (
            <li className="list-disc ml-5" key={index}>
              {step}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};
export default CalibrationInfoModal;
